
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/player-news",
      function () {
        return require("private-next-pages/[slug]/player-news/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/player-news"])
      });
    }
  